

import { useState, useRef, useEffect } from "react"
import { GeoJSON } from 'react-leaflet/GeoJSON';
import { useMapEvent, useMapEvents } from 'react-leaflet/hooks'
import axios from 'axios';
import L from "leaflet";
import {
    LayersControl,
} from 'react-leaflet';
import { divIcon } from "leaflet";
import { renderToStaticMarkup } from "react-dom/server";
import * as turf from "@turf/turf";
import Table from 'react-bootstrap/Table';

import { minedexCommodoties } from "./MinedexTypeData"
import {
    Popup,

    Source,
    Layer,
    useMap
} from 'react-map-gl/maplibre';
const GoldFinderGeoserver = axios.create({
    baseURL: process.env.REACT_APP_GOLD_FINDER_GEOSERVER
})

function queryMinedexWFS(map, setMineDexGeoJSON, minedexFilters) {
    GoldFinderGeoserver.get("/ne/ows?", {
        params: {
            service: 'WFS',
            version: '1.0.0',
            request: 'GetFeature',
            typeNames: 'ne:wa_minedex_sites',
            maxFeatures: 99999,

            outputFormat: 'application/json',
            srs: 'EPSG:4326',
            bbox: map.getBounds().toBBoxString()
        }
    }).then((e) => {

        const commodityCategories = minedexFilters.commodityCategory.map(e => e.value)

        const targetCommodoties = minedexFilters.targetCommodity.map(e => e.value)

        const siteTypes = minedexFilters.siteType.map(e => e.value);

        e.data.features = e.data.features.filter((feat) => {
            if (commodityCategories.includes(feat.properties.commodity)
                && targetCommodoties.includes(feat.properties.target_com)
                && siteTypes.includes(feat.properties.site_type_)) {

                if ((minedexFilters.siteStageProposed && feat.properties.site_stage == "Proposed")
                    || (minedexFilters.siteStageCareAndMaint && feat.properties.site_stage == "Care and Maintenance")
                    || (minedexFilters.siteStageShut && feat.properties.site_stage == "Shut")
                    || (minedexFilters.siteStageOperating && feat.properties.site_stage == "Operating")
                    || (minedexFilters.siteStageUndeveloped && feat.properties.site_stage == "Undeveloped")
                    || (minedexFilters.siteStageUnderDevelopment && feat.properties.site_stage == "Under Development")) {
                    return true;
                }

            }
        })
        setMineDexGeoJSON(e.data);
    })
};

export function lookupSingleSiteCode(id) {
    const filterQuery = ` 
    <Filter> 
        <PropertyIsEqualTo> 
            <PropertyName>site_code</PropertyName> 
            <Literal>${id}</Literal> 
        </PropertyIsEqualTo> 
    </Filter> 
    `;

    return GoldFinderGeoserver.get("/ne/ows?", {
        params: {
            service: 'WFS',
            version: '1.0.0',
            request: 'GetFeature',
            typeNames: 'ne:wa_minedex_sites',
            maxFeatures: 99999,

            outputFormat: 'application/json',
            srs: 'EPSG:4326',
            filter: filterQuery
        }
    })
}


export function MinedexOverlay({ mineDexGeoJSON, setMineDexGeoJSON, selectedFeature, setSelectedFeature, minedexFilters }) {
    const emptyGeoJson = {
        "type": "FeatureCollection",
        "name": "Mining_Tenements_DMIRS_003",
        "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:EPSG::4283" } },
        "features": []
    };

    const overlayName = "Minedex Overlay";
    const [display, setDisplay] = useState(false);
    const [selectedPopup, setSelectedPopup] = useState(<></>);

    const map = useMapEvents({
        moveend() {
            if (map.getZoom() >= 11 && display) { // this is at 5km scale
                queryMinedexWFS(map, setMineDexGeoJSON, minedexFilters);
            } else {
                setMineDexGeoJSON(emptyGeoJson);
                setSelectedPopup(<></>);
            }

        },
        overlayadd(e) {

            if (e.name == overlayName) {
                setDisplay(true);
                queryMinedexWFS(map, setMineDexGeoJSON, minedexFilters);
            }
        },
        overlayremove(e) {
            if (e.name == overlayName) {
                setSelectedPopup(<></>);
                setDisplay(false);
            }
        },
    });

    useEffect(() => {
        if (selectedFeature.type != undefined) {
            const centerPoint = turf.centerOfMass(selectedFeature.geometry);

            setSelectedPopup(
                <Popup autoPan={false} position={{ lat: centerPoint.geometry.coordinates[1], lng: centerPoint.geometry.coordinates[0] }}>
                    <Table striped bordered style={{ marginBottom: 0 }} >
                        <tbody>
                            <tr>
                                <td>Site Code:</td>
                                <td>{selectedFeature.properties.site_code}</td>
                            </tr>
                            <tr>
                                <td>Site Title:</td>
                                <td>{selectedFeature.properties.site_title}</td>
                            </tr>
                            <tr>
                                <td>Site Type:</td>
                                <td>{selectedFeature.properties.site_type_}</td>
                            </tr>
                            <tr>
                                <td>Site Sub Type:</td>
                                <td>{selectedFeature.properties.site_sub_t}</td>
                            </tr>
                            <tr>
                                <td>Site Stage:</td>
                                <td>{selectedFeature.properties.site_stage}</td>
                            </tr>
                            <tr>
                                <td>Commodity:</td>
                                <td>{selectedFeature.properties.commodity}</td>
                            </tr>
                            <tr>
                                <td>Target Commodity:</td>
                                <td>{selectedFeature.properties.target_com}</td>
                            </tr>
                            <tr>
                                <td>Site Commodity:</td>
                                <td>{selectedFeature.properties.site_commo}</td>
                            </tr>
                            <tr>
                                <td>Project Title:</td>
                                <td>{selectedFeature.properties.proj_title}</td>
                            </tr>
                            <tr>
                                <td>Project Code:</td>
                                <td>{selectedFeature.properties.proj_code}</td>
                            </tr>
                            <tr>
                                <td colSpan={2} style={{ textAlign: 'center' }}>
                                    <a target="_blank" href={selectedFeature.properties.web_link}>
                                        Minedex Link
                                    </a>
                                </td>
                            </tr>


                        </tbody>
                    </Table>
                </Popup>
            );

        } else {
            setSelectedPopup(<></>);
        }
    }, [selectedFeature])


    // get a ref to the underlying L.geoJSON
    const geoJsonRef = useRef()

    // set the data to new data whenever it changes
    useEffect(() => {
        if (geoJsonRef.current) {
            geoJsonRef.current.clearLayers()   // remove old data
            geoJsonRef.current.addData(mineDexGeoJSON) // might need to be geojson.features
        }
    }, [geoJsonRef, mineDexGeoJSON])

    useEffect(() => {
        queryMinedexWFS(map, setMineDexGeoJSON, minedexFilters);
    }, [minedexFilters])

    function createMarker(feature, latlng) {


        const iconMarkup = () => {

            // some features have a null value for this... for WHATEVER REASON
            if (feature.properties.commodity === null) {
                feature.properties.commodity = "OTHER (MINEDEX NON-MINERALS)";
            }

            const commodity = minedexCommodoties.find((e) => {
                return e.commodityId === feature.properties.commodity;
            });



            return renderToStaticMarkup(
                <i className={commodity.iconClassName} style={{ color: commodity.color }} />
            );
        }

        const customMarkerIcon = divIcon({
            html: iconMarkup(),
            className: 'dummy'
        });

        return L.marker(latlng, { icon: customMarkerIcon });

    }

    const onEachMinedexFeature = (feature, layer) => {
        layer.on('click', (e) => {
            setSelectedFeature(feature);
        })
    }

    return (
        <div>
            <LayersControl.Overlay name={overlayName}>

                <GeoJSON
                    ref={geoJsonRef}
                    data={mineDexGeoJSON.features}
                    pointToLayer={createMarker}
                    onEachFeature={onEachMinedexFeature}
                />
                {selectedPopup}
            </LayersControl.Overlay>

        </div>
    )
}


export function createSingleMinedexPopupTable(feature, latLng, setClosed) {
    return <Popup latitude={latLng.lat} longitude={latLng.lng}
        anchor="bottom"
        onClose={() => setClosed(false)}><Table striped bordered >
            <Table striped bordered >
                <tbody>
                    <tr>
                        <td>Site Code:</td>
                        <td>{feature.properties.site_code}</td>
                    </tr>
                    <tr>
                        <td>Site Title:</td>
                        <td>{feature.properties.site_title}</td>
                    </tr>
                    <tr>
                        <td>Site Type:</td>
                        <td>{feature.properties.site_type_}</td>
                    </tr>
                    <tr>
                        <td>Site Sub Type:</td>
                        <td>{feature.properties.site_sub_t}</td>
                    </tr>
                    <tr>
                        <td>Site Stage:</td>
                        <td>{feature.properties.site_stage}</td>
                    </tr>
                    <tr>
                        <td>Commodity:</td>
                        <td>{feature.properties.commodity}</td>
                    </tr>
                    <tr>
                        <td>Target Commodity:</td>
                        <td>{feature.properties.target_com}</td>
                    </tr>
                    <tr>
                        <td>Site Commodity:</td>
                        <td>{feature.properties.site_commo}</td>
                    </tr>
                    <tr>
                        <td>Project Title:</td>
                        <td>{feature.properties.proj_title}</td>
                    </tr>
                    <tr>
                        <td>Project Code:</td>
                        <td>{feature.properties.proj_code}</td>
                    </tr>
                    <tr>
                        <td colSpan={2} style={{ textAlign: 'center' }}>
                            <a target="_blank" href={feature.properties.web_link}>
                                Minedex Link
                            </a>
                        </td>
                    </tr>


                </tbody>
            </Table>
        </Table>
    </Popup >
}



export function queryMinedexWFSLibre(bboxstr, setMineDexGeoJSON, minedexFilters) {
    GoldFinderGeoserver.get("/ne/ows?", {
        params: {
            service: 'WFS',
            version: '1.0.0',
            request: 'GetFeature',
            typeNames: 'ne:wa_minedex_sites',
            maxFeatures: 99999,
            outputFormat: 'application/json',
            srs: 'EPSG:4326',
            bbox: bboxstr
        }
    }).then((e) => {


        const commodityCategories = minedexFilters.commodityCategory.map(e => e.value)

        const targetCommodoties = minedexFilters.targetCommodity.map(e => e.value)

        const siteTypes = minedexFilters.siteType.map(e => e.value);

        e.data.features = e.data.features.filter((feat) => {
            if (commodityCategories.includes(feat.properties.commodity)
                && targetCommodoties.includes(feat.properties.target_com)
                && siteTypes.includes(feat.properties.site_type_)) {

                if ((minedexFilters.siteStageProposed && feat.properties.site_stage == "Proposed")
                    || (minedexFilters.siteStageCareAndMaint && feat.properties.site_stage == "Care and Maintenance")
                    || (minedexFilters.siteStageShut && feat.properties.site_stage == "Shut")
                    || (minedexFilters.siteStageOperating && feat.properties.site_stage == "Operating")
                    || (minedexFilters.siteStageUndeveloped && feat.properties.site_stage == "Undeveloped")
                    || (minedexFilters.siteStageUnderDevelopment && feat.properties.site_stage == "Under Development")) {
                    return true;
                }

            }
        })
        setMineDexGeoJSON(e.data);
    })
};



export function MinedexOverlayMapLibre({ overlayVisibility, minedexGeoJson, setMinedexGeojson, minedexFilters }) {
    const emptyGeoJson = {
        "type": "FeatureCollection",
        "name": "assay_samples",
        "crs": { "type": "name", "properties": { "name": "urn:ogc:def:crs:EPSG::4326" } },
        "features": []
    };

    const { goldfindermap } = useMap(); // `mymap` is the id in <Map id="mymap" />

    useEffect(() => {

        if (!goldfindermap) return undefined;

        if (goldfindermap.getZoom()) {
            const bounds = goldfindermap.getBounds();
            var wfsbbox = [bounds.getSouthWest().lng, bounds.getSouthWest().lat, bounds.getNorthEast().lng, bounds.getNorthEast().lat].join();
            queryMinedexWFSLibre(wfsbbox, setMinedexGeojson, minedexFilters)
        }
    }, [minedexFilters])


    const aluminaConfig = {
        id: 'alumina-layer',
        'source': 'minedex',
        type: 'symbol',
        minzoom: 10.6,
        filter: ['==', 'commodity', 'ALUMINA'],
        layout: {
            'icon-image': 'minedex-alumina-icon',
            visibility: `${overlayVisibility.minedex ? "visible" : "none"}`
        }
    }

    const ironConfig = {
        id: 'iron-layer',
        'source': 'minedex',
        minzoom: 10.6,
        type: 'symbol',
        filter: ['==', 'commodity', 'IRON'],
        layout: {
            'icon-image': 'minedex-iron-icon',
            visibility: `${overlayVisibility.minedex ? "visible" : "none"}`
        }
    }
    const preciousMetalConfig = {
        id: 'precious-metal-layer',
        'source': 'minedex',
        minzoom: 10.6,
        type: 'symbol',
        filter: ['==', 'commodity', 'PRECIOUS METAL'],
        layout: {
            'icon-image': 'minedex-precious-metal-icon',
            //'icon-image':'red-marker',
            visibility: `${overlayVisibility.minedex ? "visible" : "none"}`
        }
    }
    const specMetalConfig = {
        id: 'minedex-specialty-metal-layer',
        'source': 'minedex',
        minzoom: 10.6,
        type: 'symbol',
        filter: ['==', 'commodity', 'SPECIALTY METAL'],
        layout: {
            'icon-image': 'minedex-specialty-metal-icon',
            visibility: `${overlayVisibility.minedex ? "visible" : "none"}`
        }
    }
    const steelAlloyConfig = {
        id: 'steel-alloy-layer',
        'source': 'minedex',
        minzoom: 10.6,

        type: 'symbol',
        filter: ['==', 'commodity', 'STEEL ALLOY METAL'],
        layout: {
            'icon-image': 'minedex-steel-alloy-metal',
            visibility: `${overlayVisibility.minedex ? "visible" : "none"}`
        }
    }
    const constructionMaterialConfig = {
        id: 'minedex-construction-material-layer',
        'source': 'minedex',
        minzoom: 10.6,
        type: 'symbol',
        filter: ['==', 'commodity', 'CONSTRUCTION MATERIAL'],
        layout: {
            'icon-image': 'minedex-construction-material-icon',
            visibility: `${overlayVisibility.minedex ? "visible" : "none"}`
        }
    }
    const baseMetalConfig = {
        id: 'base-metal-layer',
        minzoom: 10.6,
        'source': 'minedex',
        type: 'symbol',
        filter: ['==', 'commodity', 'BASE METAL'],
        layout: {
            'icon-image': 'minedex-base-metal-icon',
            visibility: `${overlayVisibility.minedex ? "visible" : "none"}`
        }
    }
    const energyConfig = {
        id: 'minedex-energy-layer',
        minzoom: 10.6,
        'source': 'minedex',
        type: 'symbol',
        filter: ['==', 'commodity', 'ENERGY'],
        layout: {
            'icon-image': 'minedex-energy-icon',
            visibility: `${overlayVisibility.minedex ? "visible" : "none"}`
        }
    }
    const indMineralConfig = {
        id: 'minedex-industrial-metal-layer',
        'source': 'minedex',
        minzoom: 10.6,
        type: 'symbol',
        filter: ['==', 'commodity', 'ALUMINA'],
        layout: {
            'icon-image': 'minedex-industrial-metal-icon',
            visibility: `${overlayVisibility.minedex ? "visible" : "none"}`
        }
    }
    const precMineralConfig = {
        id: 'minedex-precious-mineral-layer',
        'source': 'minedex',
        minzoom: 10.6,
        type: 'symbol',
        filter: ['==', 'commodity', 'ALUMINA'],
        layout: {
            'icon-image': 'minedex-precious-mineral-icon',
            visibility: `${overlayVisibility.minedex ? "visible" : "none"}`
        }
    }

    return <Source id="minedex" type="geojson" data={minedexGeoJson}>
        <Layer {...aluminaConfig} />
        <Layer {...ironConfig} />
        <Layer {...preciousMetalConfig} />
        <Layer {...specMetalConfig} />
        <Layer {...steelAlloyConfig} />
        <Layer {...constructionMaterialConfig} />
        <Layer {...baseMetalConfig} />
        <Layer {...energyConfig} />
        <Layer {...indMineralConfig} />
        <Layer {...precMineralConfig} />
    </Source>
}